module.exports = __webpack_public_path__ + "static/img/hypnose-02.f3456ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hypnose-02.png
// module id = 96
// module chunks = 0